(function(angular){
	'use strict';
	
	angular.module('homePriceChartModule', [
		'BaseConfig', 
		'highChartsModule'
	]);

})(window.angular);